module.exports = __webpack_public_path__ + "static/media/khipu-banks-163x127.fefd5f15.svg";